// extracted by mini-css-extract-plugin
export var avatarContainer = "_3n-0";
export var gray = "_3n-f";
export var green = "_3n-c";
export var icon = "_3n-9";
export var image = "_3n-1";
export var lg = "_3n-6";
export var md = "_3n-5";
export var presenceDot = "_3n-b";
export var red = "_3n-d";
export var sm = "_3n-4";
export var status = "_3n-a";
export var xl = "_3n-7";
export var xs = "_3n-3";
export var xxl = "_3n-8";
export var xxs = "_3n-2";
export var yellow = "_3n-e";